import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Users, LogOut, Map, ShieldCheck, BarChart3, Tag } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { NotificationBell } from "@/components/NotificationBell";
import { COMPANY, LOGO } from "@/lib/constants";

const LINKS = [
  { to: "/admin", label: "المعاينات", icon: LayoutDashboard, end: true, id: "nav-dashboard", perm: "view" },
  { to: "/admin/map", label: "الخريطة", icon: Map, id: "nav-map", perm: "view" },
  { to: "/admin/agents", label: "المناديب", icon: Users, id: "nav-agents", perm: "agents" },
  { to: "/admin/reports", label: "تقرير الفروع", icon: BarChart3, id: "nav-reports", perm: "view" },
  { to: "/admin/prices", label: "قائمة الأسعار", icon: Tag, id: "nav-prices", perm: "settings" },
  { to: "/admin/admins", label: "المدراء", icon: ShieldCheck, id: "nav-admins", owner: true },
];

export default function AdminLayout() {
  const { user, logout, can } = useAuth();
  return (
    <div className="min-h-screen bg-slate-50 lg:flex">
      <aside className="lg:w-64 lg:min-h-screen bg-brand-navy text-slate-200 flex lg:flex-col items-center lg:items-stretch gap-2 p-3 lg:p-5 sticky top-0 z-30">
        <div className="flex items-center gap-3 lg:mb-10 me-auto lg:me-0">
          <img src={LOGO} alt={COMPANY} data-testid="admin-logo" className="h-11 w-11 rounded-full bg-white object-contain" />
          <div className="hidden sm:block">
            <p className="font-heading font-extrabold leading-tight">لوحة الإدارة</p>
            <p className="text-xs text-brand-sky">{COMPANY}</p>
          </div>
        </div>
        <nav className="flex lg:flex-col gap-1">
          {LINKS.filter((l) => (l.owner ? user.is_owner : can(l.perm))).map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.id}
              className={({ isActive }) => `h-11 px-3 rounded-lg flex items-center gap-3 text-sm font-semibold transition-colors ${isActive ? "bg-brand-red text-white" : "hover:bg-brand-navy-dark"}`}>
              <l.icon size={18} /><span className="hidden sm:inline">{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="lg:mt-auto flex lg:flex-col gap-2 lg:border-t lg:border-line lg:pt-4">
          <p className="hidden lg:block text-xs text-brand-sky truncate" data-testid="admin-user-email">{user.name} · {user.email || user.phone}</p>
          <button onClick={logout} data-testid="logout-button" className="h-11 px-3 rounded-lg flex items-center gap-2 text-sm hover:bg-brand-navy-dark transition-colors">
            <LogOut size={18} /><span className="hidden sm:inline">خروج</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <header className="h-16 px-4 sm:px-8 flex items-center justify-end border-b border-slate-200 bg-white/95 backdrop-blur-md sticky top-0 lg:top-0 z-20">
          <NotificationBell />
        </header>
        <div className="p-4 sm:p-8"><Outlet /></div>
      </main>
    </div>
  );
}
